import isEqual from 'lodash/isEqual';
import React, { FC, useEffect, useState } from 'react';
import { InputNumber } from 'components/atoms/input';
import { PLACEHOLDER } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/constant';
import { NumberField as NumberFieldT } from 'components/organisms/tasks/fields';

interface FieldProps {
  field: NumberFieldT;
  onChange?: (selected: number | null, field: NumberFieldT) => void;
  disabled: boolean;
}

export const NumberField: FC<FieldProps> = ({ field, onChange, disabled }) => {
  const { value } = field;
  const [state, setState] = useState<number | undefined>();

  useEffect(() => {
    setState(value);
  }, [value]);

  const commit = (v: string) => {
    const selected = v.length === 0 ? null : Number(v);

    if (!isEqual(selected, value)) {
      if (onChange) {
        onChange(selected, field);
      }
    }
  };

  return (
    <InputNumber
      value={state}
      placeholder={PLACEHOLDER}
      min={field.fieldLabel === 'Points' ? 0 : field.metaData?.range?.min}
      max={field.metaData?.range?.max}
      onChange={(v) => setState(v != null ? Number(v) : undefined)}
      onPressEnter={(e) => e.currentTarget.blur()}
      onBlur={(e) => commit(e.currentTarget.value)}
      data-cy={`right.content.number.${field.fieldLabel}`}
      disabled={disabled}
    />
  );
};
